<template>
    <div class="game-enigmas">
        <enigma-toogle 
            :enigmasHeader="currentEnigmas" 
            :group="group"
            :lastSuggestionsGroup="lastSuggestions"></enigma-toogle>
    </div>
</template>
<script>
import EnigmaToogle from '../components/Game/EnigmaToogle/EnigmaToogle.vue'
export default {
    components: {
        EnigmaToogle
    },
    props : {
        group : {

        },
        lastSuggestions : {

        }
    },
    data(){
        return{
            currentEnigmas: this.$store.getters.getOpenedEnigma
        }
    },    
    created(){
        if(this.currentEnigmas.length != 0) return
        this.currentEnigmas = this.$store.getters.getSimple(["enigmas"]).enigmas
    }
}
</script>
<style lang="scss" scoped>
    .game-enigmas{
        height: 100vh;
        padding-top: 7vh;
    }

    @media only screen and (min-width: 750px){
        .game-enigmas{
            height: 100%;
            padding-top: 65px;
        }
    }
</style>
